import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    //align-items: center;
    padding: 0 11rem;
`;

export const BusCardsRow = styled.div`
    display: flex;
    gap: 2rem;
    justify-content: center;
`;

export const BackButton = styled.button<{$focused?: boolean}>`
    width: 100px;
    background: none;
    border: 2px solid #3ab8ff;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;

    &:hover {
        background-color: #3ab8ff;
        color: #000;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;

export const CardWrapper = styled.div<{$direction: 'left' | 'right'; $focused?: boolean}>`
    background-color: #1e1e1e;
    border-radius: 1rem;
    width: 100%;
    max-width: 45rem;
    padding: 1rem;
    color: white;
    font-family: 'Noto Sans KR', sans-serif;
    border: 4px solid
        ${({$direction, $focused}) =>
            $focused ? ($direction === 'left' ? '#ff6b6b' : '#4dabf7') : $direction === 'left' ? '#e74c3c' : '#3498db'};
    box-shadow: ${({$focused, $direction}) =>
        $focused
            ? $direction === 'left'
                ? '0 0 20px rgba(255, 107, 107, 0.5)'
                : '0 0 20px rgba(77, 171, 247, 0.5)'
            : 'none'};
    transition: all 0.3s ease;
    transform: ${({$focused}) => ($focused ? 'scale(1.02)' : 'scale(1)')};
`;

export const Title = styled.div`
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
`;

export const Header = styled.div<{$direction: 'left' | 'right'}>`
    display: flex;
    font-size: 1.7rem;
    font-weight: bold;
    padding: 0.5rem 1rem;
    background-color: ${({$direction}) => ($direction === 'left' ? '#e74c3c' : '#3498db')};
    border-radius: 1rem;
    margin-bottom: 1rem;

    & > :first-child {
        width: 10rem;
        padding: 1rem;
    }

    & > :nth-child(2) {
        flex: 1;
        padding: 1rem;
        color: #000;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1rem;

        & span {
            color: black;
            margin-right: 0.5rem;
            display: inline-flex;
            align-items: center;
        }
    }
`;

export const Table = styled.div<{$direction: 'left' | 'right'}>`
    width: 100%;
    background-color: ${({$direction}) => ($direction === 'left' ? '#fff0f0' : '#f0f7ff')};
    border-radius: 0.5rem;
    height: 38rem;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({$direction}) => ($direction === 'left' ? '#e74c3c' : '#3498db')};
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: ${({$direction}) => ($direction === 'left' ? '#c0392b' : '#2980b9')};
    }
`;

export const Thead = styled.div<{$direction: 'left' | 'right'}>`
    background-color: ${({$direction}) => ($direction === 'left' ? '#e74c3c' : '#3498db')};
    color: white;
    font-size: 1.5rem;

    .table-row {
        display: flex;
        width: 100%;
    }

    .table-cell {
        flex: 1;
        padding: 0.7rem;
        font-weight: bold;
        text-align: center;
        border-right: 1px solid rgba(255, 255, 255, 0.2);

        &:last-child {
            border-right: none;
        }
    }
`;

export const Tbody = styled.div`
    background-color: white;
`;

export const Row = styled.div<{$highlight: boolean; $direction: 'left' | 'right'}>`
    display: flex;
    width: 100%;
    font-size: 1rem;
    font-weight: ${({$highlight}) => ($highlight ? 'bold' : 'normal')};
    color: ${({$highlight, $direction}) => ($highlight ? ($direction === 'left' ? '#e74c3c' : '#3498db') : '#333')};

    .table-cell {
        flex: 1;
        color: black;
        font-size: 2rem;
        padding: 1.5rem 2.8rem;
        text-align: start;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;

        & .remainMinute {
            font-size: 2.5rem;
            color: ${({$direction}) => ($direction === 'left' ? '#e74c3c' : '#3498db')};
        }
    }
`;
